module.exports = __webpack_public_path__ + "img/avatar-three.30f1f55d.png";